import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import viewPhoto from 'src/common/js/viewPhoto';
export default {
    mixins: [services],
    components: {},
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {


    },
    data() {
        return {
            agent: '',
            school: '',
            form: {
                ClassList: [],
                PackageList: [],
                ListMeetPay: [{
                    changePic: [],
                }]
            },

            GoodsListNum: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            AddDialogVisible: false,
            pageIndex: 1,
            pageSize: 10,
            title: '查看订单'
        }
    },
    methods: {

        getSubmitFormData() {
            return cloneDeep({
                "ClassNum": 0,
                "ClassList": [],
                "MoreClassNum": 0,
                "OrderPrice": 0,
                "SchoolConsigneeId": 0,
                "OrderId": 0,
                "TimeStamp": 0,
                "PackageId": 1013,
                "SendMode": 223,
                "PayMode": 222,
                "ListMeetPay": [],
                "GoodsList": [],
                "AgentId": 0,
                "SchoolId": 0,
                "AgentStyle": '',
                "PayObject": '',
                OrderRemark: ''
            });
        },
        show(options) {
            this.form = {}
            jToast.show({
                type: "loading",
                text: "正在获取数据，请稍后...",
                time: -1
            });

            this.getList(options.OrderId)

        },


        // 查看图片
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },


    },
    computed: {
        totalPrice() {
            return (this.form.OrderPrice * 1 + this.form.OrderPostPrice * 1).toFixed(2)
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/BookPackage/OrderView/vm.js